<template>
  <router-view />
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { useUserStore } from '@/stores/user'
import { useEnterpriseStore } from '@/stores/enterprise'
import { useDictStore } from '@/stores/dict'
import { getAccessToken } from '@/utils/auth'

const userStore = useUserStore()
const enterpriseStore = useEnterpriseStore()
const dictStore = useDictStore()

onMounted(async () => {
  console.log('Contract Portal PC - Initialized')
  
  // 初始化字典数据
  try {
    await dictStore.setDictMap()
    console.log('字典数据已加载')
  } catch (error) {
    console.error('字典数据加载失败:', error)
  }
  
  // 如果有 token 但没有用户信息，则自动加载
  const token = getAccessToken()
  if (token) {
    // 🔧 延迟一下再加载，确保token有效
    await new Promise(resolve => setTimeout(resolve, 300))
    
    try {
      // 加载用户信息
      if (!userStore.userInfo) {
        try {
          await userStore.getUserInfo()
          console.log('用户信息已自动加载')
        } catch (userInfoError) {
          console.warn('自动加载用户信息失败（可能token刚创建还未生效）:', userInfoError)
          // 不抛出错误，让用户可以继续使用应用
        }
      }
      
      // 加载企业列表
      if (userStore.userInfo && enterpriseStore.enterpriseList.length === 0) {
        try {
          await enterpriseStore.fetchEnterpriseList()
          console.log('企业列表已自动加载')
        } catch (enterpriseError) {
          console.warn('自动加载企业列表失败:', enterpriseError)
        }
      }
    } catch (error) {
      console.error('自动加载数据失败:', error)
      // 不阻止应用加载
    }
  }
})
</script>

<style scoped>
#app {
  width: 100%;
  height: 100%;
}
</style>
